import { customFetch } from "../helpers/customFetch";
import { URL, getConfig } from "../helpers/helpers";

export const businessTypesGet = async () => {
    try {
        const configs = getConfig('GET');
        const response = await customFetch(`${URL}business_types/`, configs)
        const resData = await response.json();
        if (!response.ok) {
            return {
                ok: false,
                data: response
            }
        } else {
            return {
                ok: true,
                data: resData
            }
        }
    } catch (e) {
        console.log(e);
    }
}

export const businessTypesGetByInduction = async (id) => {
    try {
        const configs = getConfig('GET');
        const response = await customFetch(`${URL}business_types/induction/${id}`, configs)
        const resData = await response.json();
        if (!response.ok) {
            return {
                ok: false,
                data: response
            }
        } else {
            return {
                ok: true,
                data: resData
            }
        }
    } catch (e) {
        console.log(e);
    }
}